import { Calendar, Server } from 'react-feather'
import { Badge, Card, CardBody, Col, Progress, Row } from 'reactstrap'
import { formatDateOnlyPMB, formatMonthYearOnly } from 'utils/formatDate'

const DeliveryTimeline = ({ deliveryTimeLines = [] }) => {
  const getStatusBadge = (status) => {
    if (status === 'COMPLETED') {
      return (
        <Badge className="badge-verify" style={{ fontSize: '11px' }}>
          Completed
        </Badge>
      )
    } else if (status === 'OVERDUE') {
      return (
        <Badge
          className="badge-danger border-danger"
          style={{ fontSize: '11px' }}
        >
          Overdue
        </Badge>
      )
    } else {
      return (
        <Badge className="badge-blues" style={{ fontSize: '11px' }}>
          In Progress
        </Badge>
      )
    }
  }

  const getInitials = (name) => {
    return name
      ?.split(' ')
      ?.map((word) => word[0])
      ?.join('')
      ?.substring(0, 2)
      ?.toUpperCase()
  }

  // const getBadgeType = (owner) => {
  //   if (owner.includes('supplier')) return 'supplier'
  //   if (owner.includes('internal')) return 'internal'
  //   return 'supplier'
  // }

  return (
    <div className="w-100">
      {deliveryTimeLines.length === 0 ? (
        <Card className="border-0 shadow-sm">
          <CardBody className="p-4">
            <div className="text-center py-5 text-muted">
              <Server size={48} className="mb-3" />
              <p>Belum ada data delivery timeline</p>
            </div>
          </CardBody>
        </Card>
      ) : (
        <>
          <Row className="mb-3">
            <Col xs="12">
              <h6 className="mb-0 fw-semibold">Actor Delivery Timeline</h6>
            </Col>
          </Row>

          <Row>
            <Col xs="12">
              <div className="d-flex flex-column gap-3">
                {deliveryTimeLines.map((actor) => {
                  // const isExpanded = expandedActors.includes(actor.userId)
                  return (
                    <Card key={actor.userId} className="border-0 shadow-sm">
                      <CardBody className="p-3 p-md-4">
                        {/* HEADER */}
                        <div className="d-flex flex-column flex-md-row align-items-start mb-3 gap-3">
                          <div className="d-flex align-items-center gap-3 flex-grow-1">
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                width: '40px',
                                height: '40px',
                                backgroundColor: '#F9FAFB',
                                border: '1px solid #EAECF0',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#344054',
                              }}
                            >
                              {actor.assigneeUser
                                ? getInitials(actor?.assigneeUser)
                                : '-'}
                            </div>
                            <div className="flex-grow-1">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                <span className="fw-semibold">
                                  {actor.assigneeUser ?? ' -'}
                                </span>
                                {/* {actor.ownerSubtitle && (
                                  <Badge
                                    color="light"
                                    className="px-2 py-1"
                                    style={{
                                      fontSize: '11px',
                                      fontWeight: '500',
                                      color: '#667085',
                                      backgroundColor: '#F9FAFB',
                                      border: '1px solid #EAECF0',
                                    }}
                                  >
                                    {actor.ownerSubtitle
                                      ? getBadgeType(actor.ownerSubtitle)
                                      : '-'}
                                  </Badge>
                                )} */}
                              </div>
                              {/* <div className="text-muted small">
                                {actor.ownerSubtitle}
                              </div> */}
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-4 ms-md-auto">
                            <div
                              className="text-center text-md-end"
                              style={{ minWidth: '70px' }}
                            >
                              <div className="text-muted small">Deliveries</div>
                              <div className="fw-semibold">
                                {actor.deliveries}
                              </div>
                            </div>
                            <div
                              className="text-center text-md-end"
                              style={{ minWidth: '70px' }}
                            >
                              <div className="text-muted small">Completed</div>
                              <div
                                className="fw-semibold"
                                style={{ color: '#12B76A' }}
                              >
                                {actor.completed}
                              </div>
                            </div>
                            <div
                              className="text-center text-md-end"
                              style={{ minWidth: '70px' }}
                            >
                              <div className="text-muted small">Overdue</div>
                              <div
                                className="fw-semibold"
                                style={{
                                  color:
                                    actor.overdue > 0 ? '#F04438' : '#667085',
                                }}
                              >
                                {actor.overdue}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* PROJECT LIST */}
                        {actor.projects.map((project, index) => {
                          const dataParticipants =
                            project?.participants?.filter(
                              (participant) => participant.role !== 'OWNER',
                            ) || []

                          return (
                            <div key={project.id}>
                              {index > 0 && <hr className="my-3" />}

                              {/* MONTH */}
                              <div className="d-flex align-items-center gap-2 mb-3 text-muted small">
                                {project.startDate && (
                                  <>
                                    <Calendar size={14} />
                                    <span>
                                      {formatMonthYearOnly(project.startDate)}
                                    </span>
                                  </>
                                )}
                              </div>

                              <div
                                className="p-3 rounded"
                                style={{
                                  backgroundColor: project.overdue
                                    ? '#FEF3F2'
                                    : 'transparent',
                                  border: project.overdue
                                    ? '1px solid #FECDCA'
                                    : project.status === 'COMPLETED'
                                      ? '1px solid #EAECF0'
                                      : '1px solid transparent',
                                }}
                              >
                                {/* PROJECT INFO */}
                                <div className="d-flex flex-column flex-sm-row align-items-start justify-content-between mb-3 gap-2">
                                  <div className="d-flex flex-wrap align-items-center gap-2">
                                    <span className="fw-medium">
                                      {project.label}
                                    </span>
                                    {project.overdue &&
                                      getStatusBadge(project.status)}
                                  </div>
                                  <Badge
                                    className={`align-self-start ${
                                      project.status === 'COMPLETED'
                                        ? 'badge-verify'
                                        : 'badge-blues'
                                    }`}
                                    style={{ fontSize: '11px' }}
                                  >
                                    {project.status === 'COMPLETED'
                                      ? 'Completed'
                                      : 'In Progress'}
                                  </Badge>
                                </div>

                                <div className="text-muted small mb-3">
                                  Due: {formatDateOnlyPMB(project.endDate)}
                                </div>

                                {dataParticipants.length > 0 && (
                                  <div className="text-muted small mb-3 gap-3 d-flex align-items-center">
                                    <div className="text-muted small">
                                      Participants:
                                    </div>
                                    {dataParticipants?.map((member, i) => (
                                      <Badge key={i} className="w-auto ">
                                        {member?.verifiedprofile?.partnership
                                          ?.name ??
                                          member?.verifiedprofile?.name ??
                                          ''}
                                      </Badge>
                                    ))}
                                  </div>
                                )}

                                {/* PROGRESS */}
                                <div>
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <span className="small fw-medium">
                                      Progress
                                    </span>
                                    <span className="small fw-medium">
                                      {project.totalInventory.toLocaleString()}{' '}
                                      / {project.totalGoal.toLocaleString()}
                                    </span>
                                  </div>
                                  <Progress
                                    value={project.pctgVsGoal}
                                    style={{ height: '10px' }}
                                    color={
                                      project.status === 'COMPLETED'
                                        ? 'success'
                                        : project.status === 'OVERDUE'
                                          ? 'dark'
                                          : 'primary'
                                    }
                                  />
                                  <div className="small text-muted mt-2">
                                    {project.pctgVsGoal}% complete
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </CardBody>
                    </Card>
                  )
                })}
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  )
}

export default DeliveryTimeline
